import React from 'react';
import Typography from '@material-ui/core/Typography';
import MuiGrid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Wrap from './Wrap';

const ShopSection = () => {
  // eslint-disable-line
  return (
    <Wrap bgcolor="grey.100">
      <MuiGrid container spacing={2}>
        <MuiGrid item xs={null} sm={1} />
        <MuiGrid item xs={12} sm={2}>
          <Box textAlign="center">
            <img width="100%" height="auto" src="/shop.jpg" />
          </Box>
        </MuiGrid>
        <MuiGrid item xs={12} sm={8}>
          <Typography variant="h6" color="textPrimary" gutterBottom>
            Im Online-Shop des DEPI finden Verbraucher z.T. kostenloses
            Informationsmaterial zum Heizen mit Holzpellets. Fachleute finden
            darüber hinaus technisches Zubehör für Lagersicherheit und
            Pelletqualität.
          </Typography>
          <a
            href="https://depi.de/shop"
            target="_blank"
            rel="noopener noreferer"
          >
            <Typography variant="h6" color="primary">
              Zum DEPI-Shop
            </Typography>
          </a>
        </MuiGrid>
        <MuiGrid item xs={null} sm={1} />
      </MuiGrid>
    </Wrap>
  );
};

export default ShopSection;
